import React, { useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import Divider from '../../../../components/atoms/Divider'
import PageHeading from '../common/PageHeading'
import PageLayout from '../common/PageLayout'
import { useUserReadingList } from '../../../../api/denaliAssistant'
import Loading from '../../../../components/molecules/Loading'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import ReadingListMain from './ReadingListMain'
import ItemView from './ItemView'

function ReadingListHome () {
  const { path } = useRouteMatch()
  const { data, isLoading } = useUserReadingList()
  const readingList = useMemo(() => {
    const items = data?.scheduledPrompts || []
    const unread = items?.filter(x => !x.readDateUtc)
    const digests = unread.filter(x => !!x.isDigest)
    const prompts = unread.filter(x => !x.isDigest)

    // Create linked list structure from items
    const linkedList = unread.map((item, index) => ({
      scheduleId: item.scheduleId,
      name: item.name,
      prev: index > 0 ? unread[index - 1].scheduleId : null,
      prevName: index > 0 ? unread[index - 1].name : null,
      next: index < unread.length - 1 ? unread[index + 1].scheduleId : null,
      nextName: index < unread.length - 1 ? unread[index + 1].name : null
    }))

    return {
      unread,
      digests,
      prompts,
      digestCount: digests.length,
      promptCount: prompts.length,
      linkedList
    }
  }, [data])

  return (
    <PageLayout variant='constrained'>
      {isLoading ? (
        <Loading />
      ) : (
        <FadeIn>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <PageHeading title='Reading List' />
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Switch>
                <Route exact path={`${path}/item/:scheduleId`}>
                  <ItemView readingList={readingList} />
                </Route>
                <Route exact path={`${path}`}>
                  <ReadingListMain readingList={readingList} />
                </Route>
              </Switch>
            </Grid>
          </Grid>
        </FadeIn>
      )}
    </PageLayout>
  )
}

export default ReadingListHome
